import {
  Component, AfterContentInit, ElementRef, ViewChild, ViewChildren,
  QueryList, OnInit, OnDestroy
} from '@angular/core';
import { SearchSettingColumnDTO, SearchResultDTO, SearchSelectionResultDTO, getSimpleIdentifierFromString, I18nData } from '../../api/plyca-dtos';
import { ActionParameterDefinitionDTO, SearchActionResultDTO } from '../../api/plyca-dtos-v2';
import { PlycaDataService } from '../../../services/plyca.service';
import { FormGroup } from '@angular/forms';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { FieldAction, FieldConfig, SearchConfig } from '../../api/contract-notice-dto';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { EMPTY, forkJoin, from, Observable, of, throwError, timer } from 'rxjs';
import { catchError, concatMap, finalize, map, mergeMap, skipWhile, takeWhile, tap } from 'rxjs/operators';
import { BaseComponent } from '../common/baseComponent/base.component';
import { OverlayPanel } from 'primeng-lts/overlaypanel';
import { TranslateService } from '@ngx-translate/core';
import { HeaderActionsService } from '../common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { Configuration } from '../../conf/app.constants';
import { UserService } from '../../user.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { FunctionDef } from '../forms/form.objects';
import { StringNullableChain } from 'lodash';
import { Table } from 'primeng-lts/table';


enum ObjectStatus {
  PENDING,
  RUNNING,
  OK,
  ERROR
}

enum ProcessStatus {
  PENDING,
  RUNNING,
  FINISHED,
  ABORTED
}

export class SearchSettingDTOModal {
  paramsURL: ActionParameterDefinitionDTO[] = [];
  autoSearch = false;
  buscador = '';
  searchConfig: SearchConfig;
  result: any;
  valuesDepends: Map<string, any>;
  completedResult: boolean;
  // Ex
  searchExpsion: string;

  constructor(
    public idBuscador: string,
    autoSearch?: boolean,
    paramsURL?: ActionParameterDefinitionDTO[],
    completedResult?: boolean,
    searchConfig?: SearchConfig
  ) {
    this.autoSearch = autoSearch;
    this.buscador = idBuscador;
    this.paramsURL = paramsURL;
    this.completedResult = completedResult;
    this.searchConfig = searchConfig || new SearchConfig();
  }
}

@Component({
  selector: 'searchGeneric',
  templateUrl: 'searchGeneric.template.html',
  providers: [DialogService, UIService]
})
export class searchGenericComponent extends BaseComponent implements OnInit, OnDestroy, AfterContentInit {
  keyManager: any;

  @ViewChild('element') element: ElementRef;
  @ViewChild('myTable') myTable: Table;
  @ViewChildren('elementChild') elementChild: QueryList<any>;

  private context: SearchSettingDTOModal;
  model: any;

  // PARAM: indica el buscador a utilizar
  idBuscador: string;
  // PARAM: indica si al abrir el buscador se realiza automáticamente la consulta de los datos
  autoSearch = false;
  // PARAM: Indica si el buscador permite seleccionar más de un registro
  searchConfig: SearchConfig;
  // PARAM Indica si la url del buscador se invoca con parametros
  paramsURL: ActionParameterDefinitionDTO[] = [];
  // PARAM Indica si el resultado debe incluir a parte del recurso la información visualizada en el buscador
  completedResult = false;
  // PARAM Indica si mostrar la capa de espera durante la búsqueda de datos
  showWait = false;

  // Variable que crea la apariencia de la pantalla
  // Filtros
  filters: any = {};
  searchSettings: any;
  searchSettingsLoaded = false;

  // Columnas de la  tabla resultado
  public numberColums: number;
  public searchColumns: Array<SearchSettingColumnDTO> = [];
  public mappingObject = false;

  public searchExpansion: string;
  public findOneExpansion: string;

  // Columna de acciones definidas
  public rowActions: FieldAction[];
  private rowActionsFunctions: Array<FunctionDef>;

  // url del servicio de busqueda
  private urlResultSearchSetting = '';

  // Resultado del buscador
  // Array que contiene los registros con el resultado de realizar la busqueda y si esta seleccionado o no
  public resultSearch: Array<SearchResultDTO> = [];


  public windowHash: string;

  // Indica si se ha cargado o no  el servicio de consulta
  private resultSearchLoaded = false;
  // private resultSelectedLoaded = false;

  public formGroup: FormGroup;

  // propiedades de seleccion de tareas
  public allSelected = false;
  public currentStep: number;

  // estado del proceso
  readonly ProcessStatus = ProcessStatus;
  public processStatus = ProcessStatus.PENDING;
  public progressPercentage = 0;
  public startedActions = 0;
  public executedActions = 0;
  public errorActions = 0;

  public actionMessage: string;
  // private actionId: string;
  // Constantes para gestionar el estado de la accion ejecutada sobre cada objeto
  readonly MESSAGE_PROPERTY = '_stateMessage';
  readonly STATUS_PROPERTY = '_actionStatus';
  readonly ObjectStatus = ObjectStatus;

  constructor(
    private activeModal: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    public plycaService: PlycaDataService,
    public uiService: UIService,
    private translateService: TranslateService,
    protected configuration: Configuration,
    private headerActionsService: HeaderActionsService,
    private userService: UserService,
    private dialogService: DialogService,
    private pycaErrorHandler: PlycaErrorHandler,
    private plycaErrorHandler: PlycaErrorHandler,
    public waitService: WaitLoadingService
  ) {
    super();
    this.context = dialogConfig['context'];

    this.idBuscador = this.context.buscador;
    this.autoSearch = this.context.autoSearch;
    this.paramsURL = this.context.paramsURL;
    this.searchConfig = this.context.searchConfig;
    this.findOneExpansion = this.context.searchConfig?.expansion;

    this.model = dialogConfig['model'];
    this.showWait = dialogConfig['showWait'];
    this.rowActions = dialogConfig['rowActions'];
    this.rowActionsFunctions = dialogConfig['rowActionsFunctions'];



    this.currentStep = 1;
    this.completedResult = this.context.completedResult;
    this.formGroup = new FormGroup({});
  }

  ngOnInit(): void {
    if (this.showWait) {
      this.waitService.startWaiting();
    }
    this.windowHash = generateRandomIdentifier();
  }


  ngAfterContentInit(): void {
    // carga del buscador
    this.loadSearchSettings();
    if (this.element) {
      this.element.nativeElement.focus();
    }
    // carga de acciones
    this.headerActionsService.clearWindowActions(this.windowHash);
    // accion ejecutar
    this.subscribe(this.headerActionsService.addWindowAction(
      'Actions.execute',
      'fas fa-bolt',
      'btn-primary',
      () => {
        return this.searchConfig?.multiSelection && this.searchConfig?.actionCfg && this.currentStep === 1;
      },
      this.windowHash
    ), () => this.executeActions());
    // accion aceptar seleccion multiple
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.accept',
      'fa fa-check',
      'btn-primary',
      () => {
        return this.searchConfig && this.searchConfig.multiSelection && !this.searchConfig.actionCfg;
      },
      this.windowHash
    ), () => this.acceptMultipleSelection());
    // accion cancelar
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.cancel',
      'fa fa-check',
      'btn-primary',
      () => {
        return this.searchConfig && this.searchConfig.actionCfg && this.currentStep === 2;
      },
      this.windowHash
    ), () => this.cancel());
    // accion Cerrar
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.close',
      'fas fa-times',
      'btn-secondary',
      () => {
        // no hay configuracion de busqueda (seleccion simple por defecto)
        // o con configuracion de búsqueda sin accion (seleccion simple o multiple)
        // o con configuracion de accion si estoy en el paso 1 donde se seleccionan los registros sobre los que se ejecuta accion
        // o con configuracion de accion si estoy en el paso 2 ejecutando acciones y el proceso ha finalizado o ha sido abortado
        return !this.searchConfig || !this.searchConfig.actionCfg || this.currentStep === 1
          || this.processStatus === ProcessStatus.FINISHED || this.processStatus === ProcessStatus.ABORTED;
      },
      this.windowHash
    ), () => this.close());
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.dialogService = null;
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  private loadSearchSettings() {
    // Se carga la apariencia y el nombre del servicio para realizar la busqueda
    console.log('--------------ID BUSCADOR------- ' + this.idBuscador);
    this.subscribe(this.plycaService.getSearchSetting(this.idBuscador), (s: any) => {
      this.searchSettings = s;
      console.log('SEARCHSETTINGS: ', this.searchSettings);
      this.filters = {};
      this.filters['model'] = this.model;
      if (s.parametersDefinition) {
        s.parametersDefinition.forEach(function (el) {
          let info: any = el;
          if (info) {
            let value: any;
            if (info.type === 'CHECK') {
              value = false;
            }
            // Si nos llega el valor del servidor se lo asignamos
            if (value) {
              this.setNestedProperty(this.filters, info.jsonField, value);
            }

          }
        }, this);
        // for (let i in this.searchColumns) {
        //   console.log('COLUMA ', i, ': ', this.searchColumns[i].description); // "Cat", "Dog", "Hamster"
        // }
      }

      // numero de columnas del buscador
      this.numberColums = this.searchSettings.columnsSearch.length;
      console.log('COLUMNAS: ', this.numberColums);

      // Nombre de columnas y su descripción
      this.searchColumns = this.searchSettings.columnsSearch; // ColumnConfigurationGeneric (description, jsonFields:string[])
      this.mappingObject = this.searchSettings?.mappingObject;
      console.log('SEARCHCOLUMNAS: ', this.searchColumns);

      this.searchExpansion = this.searchSettings.expansion;

      // URL DE consulta del servicio
      if (this.searchSettings.links) {
        this.urlResultSearchSetting = this.searchSettings.links[0].href;
        // this.urlResultSearchSetting = this.getLinkValue('search');
        // if (!this.urlResultSearchSetting) {
        //   this.urlResultSearchSetting = this.getLinkValue('self') + '/values';
        // }
        console.log(
          '*** SEARCH GENERIC********URL DEL SERVICIO DE CONSULTA: ' +
          this.urlResultSearchSetting
        );
      }

      console.log('ATENCION!!!!! AUTOSEARCH: ', this.autoSearch);
      if (this.autoSearch) {
        this.loadSearchResult();
      } else {

        this.waitService.cancelWaiting();
      }
      this.searchSettingsLoaded = true;

    });
  }

  public setNestedProperty(obj, path, value) {
    let modifiedPath = path.replace(/\[(\d+)\]/g, '.$1')
    const pList = modifiedPath.split('.');
    const key = pList.pop();
    const pointer = pList.reduce((accumulator, currentValue) => {
      if (accumulator[currentValue] === undefined) {
        accumulator[currentValue] = {};
      }
      return accumulator[currentValue];
    }, obj);
    pointer[key] = value;
    return obj;
  }
  getLinkValue(linkType: string): string {
    let result = '';
    if (this.searchSettings.links) {
      for (let j = 0; j < this.searchSettings.links.length; j++) {
        let link = this.searchSettings.links[j];
        if (link.rel === linkType) {
          result = link.href;
        }
      }
    }
    return result;
  }

  public getNestedProperty(object, property) {
    let ret;
    if (object && typeof object === 'object') {
      if (typeof property === 'string' && property !== '') {
        // Se modifican las posiciones de arrays numericas
        let modifiedProperty = property.replace(/\[(\d+)\]/g, '.$1')
        let split = modifiedProperty.split('.');
        ret = split.reduce(function (obj, prop) {
          return obj && obj[prop];
        }, object);
      } else if (typeof property === 'number') {
        ret = object[property];
      } else {
        ret = object;
      }
    } else {
      ret = object;
    }
    //    console.log('getNestedProperty', property, ret);
    if (ret && typeof ret === 'object') {
      if (Array.isArray(ret)) {
        // Lista de valores separados por comas
        ret = ret.map(obj => { return getSimpleIdentifierFromString(obj.identifier) }).toString();
        ret = encodeURIComponent(ret);
      } else {
        ret = getSimpleIdentifierFromString(ret.identifier);
      }
    }
    return ret;
  }


  private getParamMap(): Map<string, string> {
    let paramFilter = new Map<string, string>();

    // se realiza la carga inicial de los valores que se han utilizado para la busqueda realizada
    if (this.paramsURL) {
      for (let i in this.paramsURL) {

        let nameFilter = this.paramsURL[i].identifier;
        let valueFilter = this.paramsURL[i].value;

        // Para el caso de UOSEARCH se utiliza un buscador que recibe como parámetro un objeto OrganizatinalUnit
        if (this.paramsURL[i].value != null && typeof this.paramsURL[i].value === 'object') {
          valueFilter = this.paramsURL[i].value.identifier;
        }

        // se establece el parámetro que se va a utilizar para realizar la búsqueda
        if (valueFilter) {
          paramFilter.set(nameFilter, valueFilter);
        }
      }
    }

    // a los parámetros iniciales utilizados para la precarga de la pantalla y la búsqueda inicial,
    // se añaden los parámetros de los campos visibles del formulario
    for (let i in this.searchSettings.parametersDefinition) {
      if (this.searchSettings.parametersDefinition.hasOwnProperty(i)) {
        let nameFilter = this.searchSettings.parametersDefinition[i].jsonField;
        let valueFilter = this.getNestedProperty(this.filters, nameFilter);

        if (valueFilter !== undefined && valueFilter != null && valueFilter !== '') {
          paramFilter.set(nameFilter, valueFilter);
        } else {
          // si existen parámetros inciales validamos si estos han cambiado (si fueran visibles)
          if (this.paramsURL != null) {
            // comprobamos si este campo se encuentra entre los valores inciales de precarga de la pantalla del buscador
            let paramURL = this.paramsURL.find(element => element.identifier === nameFilter);

            // borramos el filtro si se encuentra en los paramtros iniciales de precarga pero posteriormente se ha borrado su valor
            if (paramURL == null || paramURL === undefined) {
              paramFilter.delete(nameFilter);
            }
          }
        }
      }
    }
    // NIEVES??
    if (this.searchSettings && this.searchSettings.valuesDepends) {
      for (let key of this.searchSettings.valuesDepends.keys()) {
        let nameFilter = key;
        let valueFilter = this.searchSettings.valuesDepends.get(key);
        paramFilter.set(nameFilter, valueFilter);
      }
    }



    return paramFilter;

  }

  loadSearchResult(): void {
    if (this.showWait) {
      this.waitService.startWaiting();
    }

    this.subscribe(this.plycaService
      .getResultSearchSetting(
        this.urlResultSearchSetting + '/values',
        this.getParamMap()
      ).pipe(
        tap((s: any) => {
          // Si tiene registros los carga el template
          console.log('RESULTADO: ', s);
          if (s) {
            if (this.searchSettings.paginated && s.page.totalPages === 1 && s.page.totalElements > 100) {
              this.uiService.showMessage(this.translateService.instant('SearchGeneric.messages.manyRecords'));
            }
            let resultSearch = new Array<SearchResultDTO>();
            s.content.forEach(x => {
              resultSearch.push({
                content: x.columns,
                singleValue: x.singleValue,
                singleDescription: x.singleDescription,
                selected: false,
                links: x.links,
                enabled: (x?.enabled === false) ? false : true,
                formFilters: x.formFilters
              });
            });
            this.resultSearch = resultSearch;
            this.resultSearchLoaded = true;
          } else {
            this.resultSearchLoaded = false;
          }
        }



        ),
        catchError((error: any) => {
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        }),
        finalize(() => this.waitService.cancelWaiting())),


    );
  }

  isLoaded(): boolean {
    return this.searchSettingsLoaded;
  }

  isLoadedResult(): boolean {
    return this.resultSearchLoaded;
  }

  private cancel(): void {
    if (this.currentStep === 2 && this.processStatus === ProcessStatus.RUNNING) {
      // TODO i18n y ver si se permite decidir cancelación al usuario
      let dialogRef = this.uiService.showMessage('Cancelando acciones ...');
      this.subscribe(dialogRef.onClose,
        () => this.cancelProcess().pipe(
          finalize(() => this.close())
        ));
    } else {
      this.close();
    }
  }

  public select(selection: any): void {

    if (this.searchConfig && this.searchConfig.multiSelection) {
      selection.selected = !selection.selected;
    } else {
      if (this.searchConfig && this.searchConfig.actionCfg) {
        selection.selected = true;
        this.executeActions();
      } else {
        this.acceptSingleSelection(selection);
      }
    }
  }

  public acceptMultipleSelection(): void {
    if (this.resultSearch) {
      let processSelectionObs = this.getSelectedObjects().map((row: any) => this.processSelection(row).pipe(
        catchError((error: any) => {
          // ignorar error y seguir procesando
          console.error('Error procesando objeto seleccionado', row, error);
          return EMPTY;
        })
      ));
      // lanzar el procesado de todos los objetos seleccionados y devolver resultado a ventana llamante una vez finalizados
      this.subscribe(forkJoin(processSelectionObs), (result: any[]) => this.close(result));
    }
  }

  private acceptSingleSelection(selection: any): void {
    // this.translateService.instant('MultiTaskAction.Messages.WaitFinish')
    console.log('waitService.startWaiting ********************** ');
    this.waitService.startWaiting(this.translateService.instant('SearchGeneric.select.search'));
    this.subscribe(this.processSelection(selection),
      ret => {
        this.waitService.cancelWaiting();
        // No sabemos que tipo de objeto es ret, ya que puede ser el resultado de un findone, action...
        if (ret && ret.identifier && ret.identifier === 'NOK') {
          // let message = this.translateService.instant('SearchGeneric.select.error') + ': ' + ret.description;
          this.uiService.showMessage(ret.description, this.translateService.instant('General.error'), 'errorStyle');
        } else {
          this.close(ret);
        }
      },
      error => {
        this.waitService.cancelWaiting();
        let msgError = this.pycaErrorHandler.getErrorMessage(error);
        this.uiService.showMessage(msgError, this.translateService.instant('General.error'), 'errorStyle');
      });
  }

  private processSelection(selection: any): Observable<any> {
    let obj2Return: Observable<any>;
    if (selection.links) {
      let link = selection.links.find(filter => filter.rel === 'self');
      // Se consulta el objeto seleccionado
      // Se le pasan los parametros usados en la consulta
      let params = this.getParamMap();
      // Y la expansion a utilizar
      // Expansión definida desde cliente
      if (this.findOneExpansion) {
        params.set('expand', this.findOneExpansion);
      } else if (this.searchExpansion) { // Expansión definida en servidor en la definición del buscador
        params.set('expand', this.searchExpansion);
      }
      obj2Return = this.plycaService
        .getResultSearchSetting(link.href, params).pipe(
          map(ret => {
            if (selection.singleDescription) {
              ret['__description'] = selection.singleDescription;
            }
            if (this.completedResult) {
              let searchSelectionResult = new SearchSelectionResultDTO();
              searchSelectionResult.result = ret;
              searchSelectionResult.content = selection.content;
              console.log('BUSCADOR: RESULTADO DE LA BÚSQUEDA - COMPLETO: ', searchSelectionResult);
              return searchSelectionResult;
              // this.close(searchSelectionResult);
            } else {
              console.log('BUSCADOR: RESULTADO DE LA BÚSQUEDA - RECURSO: ', ret);
              return ret;
              // this.close(ret);
            }
          })
        );
    } else {
      if (selection.singleValue) {
        obj2Return = of(selection.singleValue);
      } else {
        let searchSelectionResult = new SearchSelectionResultDTO();
        if (selection.content) {
          selection.content['__description'] = selection.content.singleDescription;
        }
        searchSelectionResult.content = selection.content;
        obj2Return = of(searchSelectionResult);
      }
    }
    return obj2Return;
  }



  public createFieldConfig(filter: any, i: number): FieldConfig {
    let config = new FieldConfig();
    let path: string = filter.jsonField;
    // Habilitamos el paso de parametros desde el modelo
    if (path.startsWith('model.')) {
      config.jsonField = filter.identifier;
      let object = this.getNestedProperty(this, path);
      // this.setNestedProperty(this, config.jsonField, object);
      config.value = object;
    } else {
      config.jsonField = filter.jsonField;
    }


    // config.id = jsonField;
    if (filter.type === 'STRING') {
      if (filter.jsonField === 'ORGANISMO.RUTA') {
        config.type = 'UOSEARCH';
        this.setInputValue(path);
      } else if (filter.jsonField === 'usuId') {
        config.type = 'SEARCH';
        config.idBuscador = 'BuscadorPromotores';
      } else if (filter.typeElement === 'YES_NO') {
        config.type = 'YES_NO';
      } else {
        config.type = 'STRING';
        // precargamos los valores que vengan informados para elñ caso de campos de tipo string
        this.setInputValue(path);
      }
    } else if (filter.type === 'MULTISELECT') {
      config.type = filter.type
      config.idBuscador = filter.idSearch;
    } else if (filter.type === 'SEARCH') {
      config.idBuscador = filter.idSearch;
      config.autoSearch = true;
      config.type = 'SEARCH';
    } else if (filter.type === 'INTEGER') {
      config.type = 'INTEGER';
    } else if (filter.type === 'DECIMAL') {
      config.type = 'DECIMAL';
    } else if (filter.type === 'CURRENCY') {
      config.type = 'CURRENCY';
    } else if (filter.type === 'CHECK') {
      config.type = 'CHECK';
    } else if (filter.type === 'LIST') {
      config.type = 'DROPDOWN';

      // TODO: MODIFICAR ESTO -> SOLAMENTE SE UTILIZA MASTERDATA. SE EXTRAE LA TABLA DE LA URL
      let idBuscador: string = filter.links[0].href;
      idBuscador = idBuscador.substring(idBuscador.lastIndexOf('/') + 1);
      config.idBuscador = idBuscador;
    } else if (filter.type === 'MULTIVALUELIST') {
      config.type = 'MULTISELECT';

      // TODO: MODIFICAR ESTO -> SOLAMENTE SE UTILIZA MASTERDATA. SE EXTRAE LA TABLA DE LA URL
      let idBuscador: string = filter.links[0].href;
      idBuscador = idBuscador.substring(idBuscador.lastIndexOf('/') + 1);
      config.idBuscador = idBuscador;
    } else if (filter.type === 'YEAR') {
      config.type = 'MASK';
      config.pattern = '9999';
    }
    config.fieldStyle = 'col-6 col-xs-6';
    config.tooltipText = filter.description;
    config.description = filter.description;
    if (!filter['visible']) {
      config.visibility = '' + filter['visible'];
    }
    if (!filter['editable']) {
      config.editable = '' + filter['editable'];
    }
    // config.required = '' + filter.required;
    if (i === 0) {
      config.autofocus = true;
    }
    return config;
  }

  private setInputValue(path: string): void {

    if (this.paramsURL == null || this.paramsURL === undefined) {
      return;
    }

    // filtros inciales recibidos en la carga de la pantalla para realizar la búsqueda
    let initParamValue = this.paramsURL.find(element => element.identifier === path);

    // filtros establecidos en la pantalla
    let actualParamValue = this.getNestedProperty(this.filters, path);

    // establecemos valor del filtro si se ha mandado inicialmente para la carga de la pantalla pero no se ha pintado en la misma
    // posteriormente para las modificaciones no se realizará esta modificación
    if (initParamValue != null && actualParamValue == null) {
      this.setNestedProperty(this.filters, path, initParamValue.value);
    }
  }

  public withVisibleParameters(): boolean {
    let result = this.searchSettings.parametersDefinition && this.searchSettings.parametersDefinition.length > 0;
    if (!result) {
      return result;
    }
    result = false;
    this.searchSettings.parametersDefinition.forEach(el => {
      // En el momento en el que haya alguno visible ya se visualizan
      if (el.visible || el.visible === true) {
        result = true;
      }
    });
    // Tiene parametros, pero ninguno visible
    return result;
  }

  // metodos de acciones
  public changeAllSelection(): void {
    if (this.resultSearch) {
      this.resultSearch.forEach((row: any) => row.selected = this.allSelected);
    }
  }

  private executeActions(): void {
    const selectedObjects = this.getSelectedObjects();
    if (selectedObjects.length > 0) {
      console.log('iniciando procesamiento de tareas');
      this.currentStep = 2;

      this.myTable.reset();

      this.executedActions = 0;
      this.errorActions = 0;
      this.startedActions = 0;
      this.processStatus = ProcessStatus.RUNNING;
      // poner objectos como pendientes de ejecución
      selectedObjects.forEach((row: any) => row[this.STATUS_PROPERTY] = ObjectStatus.PENDING);
      // Poner proceso en ejecucion
      this.processStatus = ProcessStatus.RUNNING;
      // lanzar acciones
      let obs: Observable<any>;
      if (this.searchConfig.actionCfg.preExcuteFn) {
        obs = this.searchConfig.actionCfg.preExcuteFn(this.getSelectedObjects(), this.filters);
      } else {
        let result = new SearchActionResultDTO();
        result.success = true;
        obs = of(result)
      }


      this.subscribe(obs.pipe(
        mergeMap(() => from(selectedObjects)),
        takeWhile(() => this.processStatus !== ProcessStatus.ABORTED),
        // Queremos que la función definida por row, rowFn, se ejecute de forma secuencial (concatMap)
        // y no en paralelo (mergeMap), como se hacía hasta este cambio.
        concatMap((row: any, index: number) => this.executeAction(row, index)),
        finalize(() => {
          if (this.searchConfig.actionCfg.postExecuteFn && this.getSelectedObjects()) {
            this.subscribe(this.searchConfig.actionCfg.postExecuteFn(this.getSelectedObjects()));
          }
        })
      ))
    } else {
      this.uiService.showMessage(this.translateService.instant('Actions.executeSelectRecord'));
      // this.uiService.showMessage('Debe realizar una búsqueda y seleccionar un registro.');
    }
  }

  public getSelectedObjects(): any[] {
    return (this.resultSearch) ? this.resultSearch.filter((row: any) => row.selected) : [];
  }


  public showActionMessage(row: any, event: Event, overlaypanel: OverlayPanel): void {
    this.actionMessage = row[this.MESSAGE_PROPERTY];
    overlaypanel.appendTo = 'body';
    if (this.actionMessage) {
      overlaypanel.show(event);
    }
  }

  public getStatusIcon(row: any): string {
    if (row[this.STATUS_PROPERTY] === ObjectStatus.RUNNING) {
      return 'fa fa-spinner loading-spin fa-lg';
    } else if (row[this.STATUS_PROPERTY] === ObjectStatus.OK) {
      return 'fas fa-check text-success  fa-lg';
    } else if (row[this.STATUS_PROPERTY] === ObjectStatus.ERROR) {
      return 'fas fa-exclamation-circle text-danger fa-lg';
    }
  }

  public getProcessMessage(): string {
    let message: string;
    switch (this.processStatus) {
      case ProcessStatus.PENDING: {
        message = this.translateService.instant('MultiTaskAction.ProcessStatus.Pending');
        break;
      }
      case ProcessStatus.RUNNING: {
        message = this.translateService.instant('MultiTaskAction.ProcessStatus.Running');
        break;
      }
      case ProcessStatus.FINISHED: {
        if (this.errorActions) {
          message = this.translateService.instant('MultiTaskAction.ProcessStatus.FinishERR');
        } else {
          message = this.translateService.instant('MultiTaskAction.ProcessStatus.FinishOK');
        }
        break;
      }
      case ProcessStatus.ABORTED: {
        message = this.translateService.instant('MultiTaskAction.ProcessStatus.Aborted');
        break;
      }
    }
    return message;
  }

  // TODO
  private cancelProcess(): Observable<any> {
    // this.waitService.startWaiting(this.translateService.instant('MultiTaskAction.Messages.WaitFinish'));
    this.processStatus = ProcessStatus.ABORTED;
    // consultar cada 1000 si han finalizado todas las peticiones enviadas y devolver solo en ese caso
    return timer(0, 1000).pipe(
      skipWhile(() => (this.startedActions !== this.errorActions + this.executedActions)),
      tap(() => {
        // this.waitService.cancelWaiting();
        // quitar marca de ejecutando a tareas restantes
        this.getSelectedObjects().filter(row => row[this.STATUS_PROPERTY] === ObjectStatus.RUNNING)
          .forEach(row => {
            row[this.STATUS_PROPERTY] = ObjectStatus.ERROR;
            row[this.MESSAGE_PROPERTY] = 'Acción cancelada por el usuario';
          });
      })
    );
  }

  // private callAction(row: any): Observable<any> {
  //   // TODO: ejecutar accion
  //   const execTest = new ActionResultDTO();
  //   execTest.identifier = 'OK';
  //   return of(execTest).pipe(
  //     map((result: ActionResultDTO) => {
  //       if (result.identifier === 'OK') {
  //         console.log('Accion ejecutada correctamente para objeto', row);
  //         this.executedActions++;
  //         this.updateProgress();
  //         row[this.STATUS_PROPERTY] = ObjectStatus.OK;
  //         console.log('Estado del objeto', row, ' cambiado a OK');
  //         return result.objectResult;
  //       } else {
  //         this.markActionError(row, result.description);
  //         return EMPTY;
  //       }
  //     }),
  //     catchError((error: any) => {
  //       // TODO i18n
  //       this.markActionError(row, 'Se produjo un error al ejecutar la acción');
  //       return EMPTY;
  //     })
  //   );
  // }

  private executeAction(row: SearchResultDTO, index: number): Observable<any> {
    // poner objeto en ejecucion
    row[this.STATUS_PROPERTY] = ObjectStatus.RUNNING;
    // let objType = this.searchConfig.actionCfg.objectType;
    // let objIdentifier = (objType === 'USER') ? this.userService.getUserId() : row.content[this.searchConfig.actionCfg.idName];
    // if (!objIdentifier) {
    // TODO i18n
    //  this.showErrorAndClose(undefined, 'No se ha encontado el valor del identificador del recurso');
    // }
    // let parameters: string;
    // if (this.searchConfig.actionCfg.paramNames) {
    //  parameters = '';
    //  let separator = '';
    //  this.searchConfig.actionCfg.paramNames.forEach(paramColumn => {
    //    let attrValue = row.content[paramColumn];
    //    if (attrValue && attrValue.value) {
    //      parameters += separator + paramColumn + '=' + attrValue.value;
    //      separator = '&';
    //    }
    //  });
    // }

    row.formFilters = this.filters;
    return timer(250).pipe(
      takeWhile(() => this.processStatus !== ProcessStatus.ABORTED),
      // PreEjecutar
      /* mergeMap(() => {
         if (index === 0 && this.searchConfig.actionCfg.preExcuteFn) {
           return this.searchConfig.actionCfg.preExcuteFn(this.getSelectedObjects(), this.filters);
         } else {
           let result = new SearchActionResultDTO();
           result.success = true;
           return of(result)
         }
       }),*/
      // Funtion a ejecutar por selected row
      mergeMap(() => this.searchConfig.actionCfg.rowFn(row).pipe(
        tap((result: SearchActionResultDTO) => {
          if (result.success) {
            //  Funtion a ejecutar si todo ha ido OK
            if (this.searchConfig.actionCfg.okResultExecuteFn) {
              this.searchConfig.actionCfg.okResultExecuteFn(result);
            }

            console.log('Accion ejecutada correctamente para objeto', row);
            this.executedActions++;
            this.updateProgress();
            row[this.STATUS_PROPERTY] = ObjectStatus.OK;
            if (result.description && result.description != '') {
              row[this.MESSAGE_PROPERTY] = result.description;
            }
            console.log('Estado del objeto', row, ' cambiado a OK');
          } else { // TODO Action ko o Service validation !!!!!!!!!!!!
            if (this.searchConfig.actionCfg.errorResultExecuteFn) {
              this.searchConfig.actionCfg.errorResultExecuteFn(result);
            }
            this.markActionError(row, result.description);
          }
        }),
        catchError(err => {
          let errorMsg = this.pycaErrorHandler.getErrorMessage(err);


          console.error('Error al ejecutar la accion con el recurso', row, err);

          let errorResult = new SearchActionResultDTO();
          errorResult.success = false;
          errorResult.error = err;
          // errorResult.description = errorMsg;
          //  Funtion a ejecutar si se ha producido algún error
          if (this.searchConfig.actionCfg.errorResultExecuteFn) {
            this.searchConfig.actionCfg.errorResultExecuteFn(err);
          }

          this.markActionError(row, errorMsg);
          return of(err);
        })
      ))
      /*,
      // PostEjecutar
      mergeMap(() => {
        if (this.searchConfig.actionCfg.postExecuteFn && this.getSelectedObjects() && this.getSelectedObjects().length === index) {
          return this.searchConfig.actionCfg.postExecuteFn(this.getSelectedObjects());
        } else {
          return of({})
        }
      })*/
    );
  }
  private markActionError(row: any, description: string) {
    row[this.STATUS_PROPERTY] = ObjectStatus.ERROR;
    console.log('Estado del objeto ', row, ' cambiado a ERROR');
    row[this.MESSAGE_PROPERTY] = description;
    this.errorActions++;
    this.updateProgress();
  }

  private updateProgress() {
    this.progressPercentage = Math.round(((this.executedActions + this.errorActions) / this.getSelectedObjects().length) * 100);
    // if ((this.executedActions + this.errorActions) === this.getSelectedObjects().length) {
    if (this.progressPercentage === 100) {
      this.processStatus = ProcessStatus.FINISHED;
    }
  }

  private showErrorAndClose(error: any, message: string): Observable<any> {
    this.subscribe(this.uiService.showMessage(message, new I18nData('General.error')).onClose,
      () => this.close());
    return throwError(error || message);
  }
  private close(data?: any): void {
    this.activeModal.close(data);
  }

  public isActiveRowAction(action: FieldAction, rowData?: any): boolean {
    let ret = true;
    if (typeof action.enabled === 'boolean') {
      return action.enabled;
    } else if (action.enabled) {
      try {
        return this.evalExpression(action.enabled, rowData);

      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }

  public isVisibleRowAction(action: FieldAction, rowData?: any): boolean {
    let ret = true;
    if (typeof action.visibility === 'boolean') {
      return action.visibility;
    } else if (action.visibility) {
      try {
        return this.evalExpression(action.visibility, rowData);
      } catch (ex) {
        console.log('Error', ex);
        ret = true;
      }
    }
    return ret;
  }


  public executeRowAction(action: FieldAction, _model?: any): void {
    if (!_model) {
      _model = this.model;
    }
    if (this.rowActionsFunctions && action.functionName) {
      let func = this.rowActionsFunctions.find(
        x => x.identifier === action.functionName
      );
      if (func) {
        let mod = func.fn.call(this, _model);


        console.log('action.functionName function invocada', mod);

      }
    }
  }




  public evalExpression(expression: string, obj: any): any {
    let tmpFunc = new Function('return ' + expression);
    let value = tmpFunc.apply(obj);
    return value;
  }

  public showDisabledMsg() {
    this.uiService.showMessage('No es posible seleccionar este elemento.');
  }
}
